import { AdvancedSearchFormValues } from "./types";

export interface FilterChipConfig {
  label: string; // prikazana oznaka filtera, npr. "Stanje"
  display?: (value: any) => string; // vrijednost -> tekst chipa, npr. "new" -> "Novo"
}

/**
 * Deklarativno generira chipove (AdvancedSearchFormValues) iz filter-vrijednosti za zadana polja.
 * Skalira na proizvoljno mnogo filtera — dodavanje novog = jedan redak u configu. Prazna polja
 * (null / "") se preskaču; `value` se stringificira jer chip drži string.
 *
 *   const chips = buildFilterChips(formValues, {
 *     condition: { label: "Stanje", display: (v) => v === "new" ? "Novo" : "Rabljeno" },
 *   });
 */
export const buildFilterChips = <T extends object>(
  values: T,
  config: Partial<Record<keyof T, FilterChipConfig>>
): AdvancedSearchFormValues[] => {
  const chips: AdvancedSearchFormValues[] = [];
  for (const [field, cfg] of Object.entries(config) as [string, FilterChipConfig][]) {
    const value = (values as any)[field];
    if (value == null || value === "") continue;
    const text = cfg.display ? cfg.display(value) : String(value);
    chips.push({ name: field, value: String(value), text, displayName: text, label: cfg.label });
  }
  return chips;
};
